import { render, staticRenderFns } from "./conversation-master.vue?vue&type=template&id=e2451412&scoped=true"
import script from "./conversation-master.ts?vue&type=script&lang=ts&external"
export * from "./conversation-master.ts?vue&type=script&lang=ts&external"
import style0 from "./conversation-master.less?vue&type=style&index=0&id=e2451412&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2451412",
  null
  
)

export default component.exports